module.exports = __webpack_public_path__ + "img/temperature-empty.e4704e64.svg";